import { isWithinInterval, isBefore, parseISO, format, parse } from "date-fns"

export const sep = "/"

export const policyPattern = /^[MmFf][a-zA-Z0-9,d]{7}$/
export const masterAccountPattern = /^[6][0-9,d]{7}$/
export const namepattern = /^[a-zA-Z .,+-@/()'&]*$/
export const nricpattern = /^[STFGMstfgm]\d{7}[A-Za-z]$/
export const mobilepattern = /^[89][0-9,\d]{7}$/
export const amountpattern = /^[1-9]\d*(,[0-9]{1,3}){0,2}?(\.[0-9]{1,2})?$/
export const refundAmountpattern = /^[0-9]\d*(,[0-9]{1,3}){0,9}?(\.[0-9]{1,2})?$/
export const datepattern = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/[0-9]{4}$/
export const timepattern = /^([01]?[0-9]|2[0-3]):([0-5][0-9]){1}?$/

export const futureTimeErrorMsg = "Future time is not allowed"

const validWording = "Please enter valid "

export const windscreenCoverageIdForDocument = 134

export const descOfDamageNeedPoliceReportUplaod =
  "Shattered or Broken Parked & found damage (Vandalism)"

export const natureOfDamageOther = "Other Description of Incident"

export const policeReportDocumentID = 177

//Workshop Information
export const workshopErrorMsg = "Please select a workshop"
export const workshopNameErrorMsg = validWording + "workshop name"
export const workshopContactNoErrorMsg =
  validWording + "workshop contact number"
export const workshopAddressErrorMsg = validWording + "workshop address"
export const workshopContactPersonErrorMsg = validWording + "contact person"
export const workshopEmailErrorMsg = validWording + "workshop email"
//Policy Information
export const policyNumberErrorMsg = validWording + "policy number"
export const vehicleNumberErrorMsg = validWording + "vehicle number"
//Details Of Policy
export const policyHolderNameErrorMsg = validWording + "name of insured"
export const claimantNricErrorMsg = validWording + "NRIC/PP No"
export const claimantEmailErrorMsg = validWording + "email"
export const claimantMobileErrorMsg = validWording + "mobile number"

//Particulars Of Driver
export const driverNameErrorMsg = validWording + "driver's name"
export const driverICErrorMsg = validWording + "driver's NRIC No."
export const driverAddressErrorMsg = validWording + "driver's address"
export const driverOccupationErrorMsg = "Please select driver's occupation"
export const otherDriverOccupationErrorMsg =
  validWording + "driver's occupation"
export const driverMobileNoErrorMsg = validWording + "driver's Mobile No."

//Particulars Of Accident
export const accidentDateErrorMsg = validWording + "accident date"
export const accidentTimeErrorMsg = validWording + "accident time"
export const accidentDateWithinPeriodErrorMsg =
  "Accident date must within policy period"
export const accidentLocationErrorMsg = validWording + "location of accident"
export const otherNatureOfDamageErrorMsg =
  validWording + "description of incident"
export const claimAmountErrorMsg =
  validWording + "estimated total repair amount"

export const combineDateAndTime = (inputDate, inputTime) => {
  if (inputDate && inputTime) {
    const formattedDate = format(inputDate, "yyyy-MM-dd")
    const combinedResult = formattedDate + "T" + inputTime + ":00"

    return combinedResult
  }
}

export const notFutureDatime = (inputDate, inputTime) => {
  if (inputDate && inputTime) {
    let formattedDateTime = parseISO(combineDateAndTime(inputDate, inputTime))
    return isBefore(formattedDateTime, new Date())
  }
}

export const withinPeriod = (startDate, endDate, inputDate) => {
  if (startDate && endDate && inputDate) {
    const startDateTime = parse(startDate, `d${sep}M${sep}yyyy`, new Date())
    const endDateTime = parse(endDate, `d${sep}M${sep}yyyy`, new Date())
    let inputDateTime = parseISO(combineDateAndTime(inputDate, "00:00"))

    return isWithinInterval(inputDateTime, {
      start: startDateTime,
      end: endDateTime,
    })
  } else {
    return true
  }
}
